import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

// Lista de idiomas que tienen archivo de enfermedades disponible
const supportedDiseaseLangs = ["en", "es", "fr", "de", "it", "pl", "ro", "nl", "pt", "el"];

/**
 * Función para cargar dinámicamente enfermedades traducidas
 * según el idioma activo de i18n.
 *
 * @returns Promise con array de enfermedades o array vacío en error
 */
export const loadDiseasesByLang = async (lang?: string): Promise<string[]> => {
  const langCode = (lang || i18n.language || "en").split("-")[0];
  const finalLang = supportedDiseaseLangs.includes(langCode) ? langCode : "en";

  try {
    const res = await fetch(`/enfermedades/enfermedades_${finalLang}.json`);
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.warn(`❌ No se pudo cargar enfermedades_${finalLang}.json`, err);
    return [];
  }
};

i18n
  .use(HttpBackend) // carga los archivos de traducción vía HTTP desde /public
  .use(LanguageDetector) // detecta automáticamente el idioma del navegador
  .use(initReactI18next) // integración con React
  .init({
    fallbackLng: "en",
    supportedLngs: supportedDiseaseLangs,
    ns: ["translation", "perfil_funcional"], // los namespaces disponibles
    defaultNS: "translation",

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    },

    interpolation: {
      escapeValue: false
    },

    debug: false
  });

export default i18n;
